import track from './track';
import trackingObserver from './tracking-observer';

export {
  track,
  trackingObserver,
}



// WEBPACK FOOTER //
// src/tracking/index.js